import { NavLink, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/menus", label: "Menus" },
  { to: "/carte-bistro", label: "Carte" },
  { to: "/boissons", label: "Boissons" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-shadow duration-300 bg-[#FDFBF7] border-b border-[#A61C24]/35 ${
        scrolled ? "shadow-[0_2px_10px_-4px_rgba(10,10,10,0.15)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 grid grid-cols-[1fr_auto_1fr] items-center">
        <Link to="/" className="flex items-center justify-self-start" data-testid="logo-link">
          <img src="/images/logo.png" alt="Le Bistrot de la Neuve" width="170" height="44" className="h-10 md:h-11 w-auto object-contain" />
        </Link>

        <nav className="hidden md:flex items-center gap-10 justify-self-center">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `nav-link text-sm uppercase tracking-[0.2em] transition-colors ${
                  isActive
                    ? "active text-[#A61C24]"
                    : "text-[#1A1A1A]/75 hover:text-[#A61C24]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3 justify-self-end">
          <Link
            to="/contact"
            data-testid="reserver-btn"
            className="hidden sm:inline-flex items-center px-6 py-2.5 bg-[#A61C24] hover:bg-[#8B151E] text-white text-xs tracking-[0.25em] uppercase font-medium transition-colors duration-200"
          >
            Réserver
          </Link>
          <button
            aria-label="Menu"
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-[#1A1A1A] p-2"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#FDFBF7] border-t border-[#E5E0D8]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.2em] ${isActive ? "text-[#A61C24]" : "text-[#1A1A1A]/80"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="reserver-btn-mobile"
              className="inline-flex items-center justify-center px-6 py-2.5 bg-[#A61C24] text-white text-xs tracking-[0.25em] uppercase"
            >
              Réserver
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
